
import React from "react";
import { Input } from "../ui/input";

interface FormInputProps {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  readOnly?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  readOnly = false,
}) => {
  return (
    <div className="w-full mt-6 max-md:max-w-full">
      <label className="block text-foreground leading-[1.4] max-md:max-w-full">
        {label}
      </label>
      <Input
        type="text"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || ""}
        readOnly={readOnly}
        className={`bg-card border min-w-60 w-full overflow-hidden leading-none mt-2 px-4 py-3 rounded-lg h-auto ${
          error ? "border-destructive" : "border-border"
        } max-md:max-w-full text-foreground placeholder:text-muted-foreground ${
          readOnly ? "opacity-70 cursor-not-allowed" : ""
        }`}
      />
      {error && (
        <p className="text-destructive text-xs italic mt-1">{error}</p>
      )}
    </div>
  );
};

export default FormInput;
